module.exports = __webpack_public_path__ + "6c48a3bd7861d3a8a1ccdb74449a9118.svg";